import {useLazyQuery, useQuery} from '@apollo/client';
import {useParams} from 'react-router-dom';
import {useEffect} from 'react';
import {LIST_OV_RECOMMENDATIONS} from '../features/recommendations/RecommendsGrid/ovPotQueries';
import {OVRecommends, OVRecommendsVariables} from '../schema-types/OVRecommends';
import {useAccountContext} from '../contexts/AccountContext';
import validateUUID from '../utils/validateUUID';

export const useAccountOVRecommends = () => {
  const {accountId} = useAccountContext();
  const {data, error, loading} = useQuery<OVRecommends, OVRecommendsVariables>(
    LIST_OV_RECOMMENDATIONS,
    {
      variables: {
        entityName: 'account',
        entityId: validateUUID(accountId),
      },
      fetchPolicy: 'network-only',
      skip: !accountId,
    }
  );

  return {data, error, loading};
};

export const useReviewOVRecommends = () => {
  const {reviewId} = useParams();
  const [onFetch, {data, error, loading}] = useLazyQuery<
    OVRecommends,
    OVRecommendsVariables
  >(LIST_OV_RECOMMENDATIONS, {
    variables: {
      entityName: 'review',
      entityId: validateUUID(reviewId),
    },
    fetchPolicy: 'network-only',
  });
  useEffect(() => {
    let clear: NodeJS.Timeout | null;
    if (reviewId) {
      clear = setTimeout(() => {
        onFetch({
          variables: {
            entityName: 'review',
            entityId: validateUUID(reviewId),
          },
        });
      }, 10000);
    }
    return () => {
      if (clear) {
        clearTimeout(clear);
      }
    };
  }, [reviewId]);

  return {data, error, loading};
};

export const useOVRecommends = (isAccount = false) => {
  const {reviewId} = useParams();
  const {accountId} = useAccountContext();
  const {data, error, loading} = useQuery<OVRecommends, OVRecommendsVariables>(
    LIST_OV_RECOMMENDATIONS,
    {
      variables: {
        entityName: isAccount ? 'account' : 'review',
        entityId: isAccount ? validateUUID(accountId) : validateUUID(reviewId),
      },
      skip: isAccount ? !accountId : !reviewId,
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'network-only',
    }
  );
  return {data, error, loading};
};
